import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "../../../components/alerts";
import medicGeekApi from "../../../config/axiosConfig";
import "./../../../styles/FormPro.css";

const CategoryList = ({ currentForm }) => {
  const [categorys, setCategorys] = useState([]);
  const [showForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const categorysPerPage = 10;
  const [selectedCategoryLocal, setSelectedCategoryLocal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [paletaColor, setPaletaColor] = useState("");
  const [paletaColorMap, setPaletaColorMap] = useState("");
  const [paletaColorData, setPaletaColorData] = useState([]); // Define e inicializa paletaColorData

  // Skeleton
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const [formulario, setFormulario] = useState({
    nombreCategory: "",
    descripcionCategory: "",
    estatusCategory: "activo",
  });

  const openModal = (category) => {
    setSelectedCategoryLocal(category);
    if (category) {
      setIsEditing(true);
      const selectedColor = paletaColorMap[category.colorId];
      setFormulario({
        colorId: category.colorId, // Asegura que el colorId se establezca correctamente
        nombreCategory: category.categoryNm,
        descripcionCategory: category.categoryDesc,
        estatusCategory: category.estatus ? "activo" : "inactivo",
        colorRgb: selectedColor,
      });
    } else {
      setIsEditing(false);
      setFormulario({
        colorId: "", // Limpia el colorId al crear una nueva categoría
        nombreCategory: "",
        descripcionCategory: "",
        estatusCategory: "activo",
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedCategoryLocal(null);
    setIsEditing(false);
    setModalOpen(false);
  };

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm]);

  const fetchData = async () => {
    setLoading(true); // Iniciar la carga
    try {
      // Cargar las categorías
      const response = await medicGeekApi.get(
        `/categorys?search=${searchTerm}`
      );
      const sortedCategory = response.data.sort(
        (a, b) => a.categoryId - b.categoryId
      );

      // Cargar los colores de la paleta desde la API
      const paletaColorResponse = await medicGeekApi.get("/paletaColors");
      const paletaColorData = paletaColorResponse.data;
      setPaletaColorData(paletaColorData); // Actualiza el estado con los datos de colores

      // Crear un mapa de colorId -> colorRgb
      const paletaColorMap = {};
      paletaColorData.forEach((paletaColor) => {
        paletaColorMap[paletaColor.colorId] = paletaColor.colorRgb;
      });

      // Combinar las categorías con sus colores
      const categoryDataWithColor = sortedCategory.map((category) => ({
        ...category,
        colorRgb: paletaColorMap[category.colorId] || "rgb(255, 0, 0)", // Color por defecto
      }));

      // Actualiza el estado de categorías con el color asignado
      setCategorys(categoryDataWithColor);
      setPaletaColorMap(paletaColorMap); // Guarda el mapa de colores
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Finalizar carga
    }
  };

  const pageCount = Math.ceil(categorys?.length / categorysPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const displayedCategory = categorys
    .filter((category) => {
      // Filtrar category basados en el término de búsqueda
      return (
        category.categoryNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
        category.categoryDesc.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
    .slice(pageNumber * categorysPerPage, (pageNumber + 1) * categorysPerPage);

  const guardarNuevaCategory = () => {
    if (!formulario.colorId) {
      showErrorAlert(
        "Debes seleccionar un color antes de Guardar la Categoria"
      );
      return;
    }
    const nuevoCategory = {
      categoryNm: document.getElementById("nombreCategory").value,
      categoryDesc: document.getElementById("descripcionCategory").value,
      colorId: formulario.colorId,
      estatus:
        document.getElementById("estatusCategory").value === "activo"
          ? "Activo"
          : "Inactivo",
    };

    medicGeekApi
      .post("/categorys", nuevoCategory)
      .then((response) => {
        showSuccessAlert();
        closeModal();
        fetchData();
      })
      .catch((error) => {
        console.error("Error al crear el categoria", error);
      });
  };

  const editarCategory = () => {
    if (!formulario.colorId) {
      showErrorAlert(
        "Debes seleccionar un color antes de Guardar la Categoria"
      );
      return;
    }
    if (selectedCategoryLocal && selectedCategoryLocal.categoryId) {
      const { categoryId } = selectedCategoryLocal;
      const nombreCategory = document.getElementById("nombreCategory").value;
      const descripcionCategory = document.getElementById(
        "descripcionCategory"
      ).value;
      const colorName = document.getElementById("colorCategory").value;
      const estatusCategory =
        document.getElementById("estatusCategory").value === "activo"
          ? "Activo"
          : "Inactivo";

      const updatedCategory = {
        categoryId, // Asegurarse de enviar el ID
        categoryNm: nombreCategory,
        categoryDesc: descripcionCategory,
        colorId: colorName,
        estatus: estatusCategory,
      };

      medicGeekApi
        .patch(`/categorys/${categoryId}`, updatedCategory)
        .then((response) => {
          showSuccessEditAlert();
          closeModal();
          fetchData();
          // updateCategoryList();
        })
        .catch((error) => {
          console.error("Error al actualizar la Categoria", error);
        });
    } else {
      // Manejo de error o mensaje de que no se puede actualizar
      showErrorAlert("No se puede actualizar: Categoria no válido.");
    }
  };

  const eliminarCategory = (categoryId) => {
    const confirmacion = window.confirm(
      "¿Estás seguro de que deseas eliminar esta categoría?"
    );

    if (!confirmacion) {
      return;
    }

    medicGeekApi
      .delete(`/categorys/${categoryId}`)
      .then((response) => {
        showSuccessAlert("Categoría eliminada exitosamente.");
        fetchData(); // Vuelve a cargar los datos después de eliminar
      })
      .catch((error) => {
        console.error("Error al eliminar la categoría", error);
        showErrorAlert("Hubo un error al eliminar la categoría.");
      });
  };

  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "70px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}
        ></div>
      </td>
    </tr>
  );

  return (
  <div className="pro-container">

    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <div className="pro-header">

      <div className="pro-header-left">
        <h2 className="pro-title">Categoría</h2>
        <p className="pro-subtitle">
          Gestión y mantenimiento de categorías
        </p>
      </div>

      <div className="pro-actions">

        <div className="pro-search">

          <i className="bi bi-search"></i>

          <input
            type="search"
            placeholder="Buscar categoría..."
            value={searchTerm}
            onChange={handleSearchTermChange}
          />

        </div>

        <button
          type="button"
          className="pro-btn-primary"
          onClick={() => openModal(null)}
        >
          <i className="bi bi-plus-circle"></i>
          Nueva Categoría
        </button>

      </div>

    </div>

    {/* ===================================================== */}
    {/* TABLE DESKTOP */}
    {/* ===================================================== */}

    <div className="pro-card d-none d-md-block">

      <div className="table-responsive">

        <table className="table pro-table">

          <thead>

            <tr>
              <th style={{ width: "5%" }}>ID</th>
              <th style={{ width: "20%" }}>Nombre</th>
              <th style={{ width: "35%" }}>Descripción</th>
              <th style={{ width: "10%" }}>Color</th>
              <th style={{ width: "15%" }}>Estado</th>
              <th style={{ width: "15%" }}>Acciones</th>
            </tr>

          </thead>

          <tbody>

            {loading ? (

              Array.from({ length: 15 }).map((_, index) => (
                <SkeletonTableRow key={index} />
              ))

            ) : (

              displayedCategory.map((category) => (

                <tr key={category.categoryId}>

                  <td>
                    #{category.categoryId}
                  </td>

                  <td className="fw-semibold">
                    {category.categoryNm}
                  </td>

                  <td
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={category.categoryDesc}
                  >
                    {category.categoryDesc?.length > 40
                      ? `${category.categoryDesc.slice(0, 40)}...`
                      : category.categoryDesc}
                  </td>

                  <td>

                    <div className="d-flex align-items-center gap-2">

                      <span
                        style={{
                          width: "18px",
                          height: "18px",
                          borderRadius: "50%",
                          backgroundColor: category.colorRgb,
                          display: "inline-block",
                          border: "2px solid #fff",
                          boxShadow: "0 0 0 1px #cbd5e1",
                        }}
                      ></span>

                      <small className="text-muted">
                        {category.colorRgb}
                      </small>

                    </div>

                  </td>

                  <td>

                    <span
                      className={`expediente-badge ${
                        category.estatus === "Activo"
                          ? ""
                          : "gender-badge"
                      }`}
                    >
                      {category.estatus}
                    </span>

                  </td>

                  <td>

                    <div className="pro-table-actions">

                      <button
                        type="button"
                        className="pro-action-btn primary"
                        title="Editar"
                        onClick={() => openModal(category)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>

                      <button
                        type="button"
                        className="pro-action-btn warning"
                        title="Eliminar"
                        onClick={() =>
                          eliminarCategory(category.categoryId)
                        }
                      >
                        <i className="bi bi-trash"></i>
                      </button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

    {/* ===================================================== */}
    {/* MOBILE CARDS */}
    {/* ===================================================== */}

    <div className="d-md-none">

      <div className="row">

        {loading ? (

          Array.from({ length: 5 }).map((_, index) => (

            <div className="col-12 mb-3" key={index}>

              <div className="mobile-patient-card">

                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line"></div>

              </div>

            </div>

          ))

        ) : (

          displayedCategory.map((category) => (

            <div
              className="col-12 mb-3"
              key={category.categoryId}
            >

              <div className="mobile-patient-card">

                <div className="mobile-card-top">

                  <div className="patient-info">

                    <div
                      className="patient-avatar"
                      style={{
                        background: category.colorRgb,
                      }}
                    >
                      {category.categoryNm?.charAt(0)}
                    </div>

                    <div>

                      <div className="patient-name">
                        {category.categoryNm}
                      </div>

                      <div className="patient-id">
                        Categoría #{category.categoryId}
                      </div>

                    </div>

                  </div>

                </div>

                <div className="mb-3">

                  <small className="text-muted d-block mb-1">
                    Descripción
                  </small>

                  <div>
                    {category.categoryDesc}
                  </div>

                </div>

                <div className="mb-3">

                  <small className="text-muted d-block mb-1">
                    Color
                  </small>

                  <div className="d-flex align-items-center gap-2">

                    <span
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%",
                        backgroundColor: category.colorRgb,
                        display: "inline-block",
                        border: "2px solid #fff",
                        boxShadow: "0 0 0 1px #cbd5e1",
                      }}
                    ></span>

                    <span>
                      {category.colorRgb}
                    </span>

                  </div>

                </div>

                <div className="mb-3">

                  <small className="text-muted d-block mb-1">
                    Estado
                  </small>

                  <span
                    className={`expediente-badge ${
                      category.estatus === "Activo"
                        ? ""
                        : "gender-badge"
                    }`}
                  >
                    {category.estatus}
                  </span>

                </div>

                <div className="mobile-card-actions">

                  <button
                    type="button"
                    className="pro-action-btn primary"
                    onClick={() => openModal(category)}
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  <button
                    type="button"
                    className="pro-action-btn warning"
                    onClick={() =>
                      eliminarCategory(category.categoryId)
                    }
                  >
                    <i className="bi bi-trash"></i>
                  </button>

                </div>

              </div>

            </div>

          ))

        )}

      </div>

    </div>

    {/* ===================================================== */}
    {/* PAGINATION */}
    {/* ===================================================== */}

    {!showForm && (

      <div className="pro-pagination">

        <nav aria-label="Page navigation example">

          <ul className="pagination modern-pagination">

            {/* PREVIOUS */}

            <li
              className={`page-item ${
                pageNumber === 0 ? "disabled" : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber - 1,
                  })
                }
                style={{
                  cursor:
                    pageNumber === 0
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                <i className="bi bi-chevron-left"></i>
              </span>

            </li>

            {/* NUMBERS */}

            {Array.from(
              { length: Math.min(pageCount, 10) },
              (_, index) => (

                <li
                  key={index}
                  className={`page-item ${
                    pageNumber === index
                      ? "active"
                      : ""
                  }`}
                >

                  <span
                    className="page-link"
                    onClick={() =>
                      handlePageChange({
                        selected: index,
                      })
                    }
                  >
                    {index + 1}
                  </span>

                </li>

              )
            )}

            {/* NEXT */}

            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <span
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber + 1,
                  })
                }
                style={{
                  cursor:
                    pageNumber === pageCount - 1
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                <i className="bi bi-chevron-right"></i>
              </span>

            </li>

          </ul>

        </nav>

      </div>

    )}

    {/* ===================================================== */}
    {/* MODAL */}
    {/* ===================================================== */}

    {currentForm === "categoryForm" &&
      selectedCategoryLocal && (
        <div className="main-content"></div>
      )}

    <Modal
      isOpen={modalOpen}
      toggle={closeModal}
      centered
      className="pro-modal"
    >

      <ModalHeader toggle={closeModal}>

        {isEditing
          ? "Editar Categoría"
          : "Nueva Categoría"}

      </ModalHeader>

      <ModalBody>

        <Form>

          <FormGroup className="mb-3">

            <Label for="nombreCategory">
              Nombre de la Categoría
            </Label>

            <Input
              type="text"
              id="nombreCategory"
              className="pro-input"
              value={formulario.nombreCategory}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  nombreCategory: e.target.value,
                })
              }
            />

          </FormGroup>

          <FormGroup className="mb-3">

            <Label for="descripcionCategory">
              Descripción
            </Label>

            <Input
              type="text"
              id="descripcionCategory"
              className="pro-input"
              value={formulario.descripcionCategory}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  descripcionCategory: e.target.value,
                })
              }
            />

          </FormGroup>

          <FormGroup className="mb-3">

            <Label for="colorCategory">
              Color
            </Label>

            <Input
              type="select"
              id="colorCategory"
              className="pro-input"
              value={formulario.colorId}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  colorId: e.target.value,
                })
              }
            >

              <option value="">
                Selecciona un color
              </option>

              {paletaColorData.map((color) => (

                <option
                  key={color.colorId}
                  value={color.colorId}
                >
                  {color.colorName || color.name}
                </option>

              ))}

            </Input>

          </FormGroup>

          <FormGroup>

            <Label for="estatusCategory">
              Estado
            </Label>

            <Input
              type="select"
              id="estatusCategory"
              className="pro-input"
              value={formulario.estatusCategory}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  estatusCategory: e.target.value,
                })
              }
            >

              <option value="activo">
                Activo
              </option>

              <option value="inactivo">
                Inactivo
              </option>

            </Input>

          </FormGroup>

        </Form>

      </ModalBody>

      <ModalFooter>

        <Button
          className="pro-btn-cancel"
          onClick={closeModal}
        >
          Cancelar
        </Button>

        <Button
          className="pro-btn-save"
          onClick={
            isEditing
              ? editarCategory
              : guardarNuevaCategory
          }
        >
          {isEditing
            ? "Guardar Edición"
            : "Guardar"}
        </Button>

      </ModalFooter>

    </Modal>

  </div>
  );
};
export default CategoryList;
